module.exports = __webpack_public_path__ + "files/49e85bf10da1a31a884ec4f2f8b4eeea.svg";